export default [
  {
    path: '/coupons/:id',
    name: 'CouponRetrieveUpdate',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/subscription/CouponRetrieveUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Cupón'
    }
  },
  {
    path: '/coupons',
    name: 'CouponListCreate',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/subscription/CouponListCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Cupones'
    }
  },
  {
    path: '/addons/:id',
    name: 'AddonRetrieveUpdate',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/subscription/AddonRetrieveUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Complemento'
    }
  },
  {
    path: '/addons',
    name: 'AddonListCreate',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/subscription/AddonListCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Complementos'
    }
  },
  {
    path: '/products',
    name: 'ProductListCreate',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/subscription/ProductListCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Productos'
    }
  },
  {
    path: '/products/:id',
    name: 'ProductRetrieveUpdate',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/subscription/ProductRetrieveUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Producto'
    }
  },
  {
    path: '/plans/create',
    name: 'PlanCreate',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/subscription/PlanCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Crear plan'
    }
  },
  {
    path: '/plans/:id',
    name: 'PlanRetrieveUpdate',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/subscription/PlanRetrieveUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Plan'
    }
  },
  {
    path: '/subscriptions/create',
    name: 'SubscriptionCreate',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/subscription/SubscriptionCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Crear suscripción'
    }
  },
  {
    path: '/subscriptions/:id',
    name: 'SubscriptionRetrieve',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/subscription/SubscriptionRetrieve.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Suscripción'
    }
  },
  {
    path: '/subscriptions',
    name: 'SubscriptionList',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/subscription/SubscriptionList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Suscripciones'
    }
  },
  {
    path: '/subscriptions/:id/edit',
    name: 'SubscriptionUpdate',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/subscription/SubscriptionUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Editar suscripción'
    }
  },
  {
    path: '/usages',
    name: 'UsageListCreate',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/subscription/UsageListCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'SubscriptionList',
      requireAuth: true,
      requireAccount: true,
      title: 'Registros de uso'
    }
  }
]